/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ObservableComponentBase from "./ObservableComponentBase";

/** @hidden */
const ccclass = cc._decorator.ccclass;
/** @hidden */
const property = cc._decorator.property;

/** Implementation of [[ObservableComponentBase]] for observing a [[cc.Node]] value. */
@ccclass
export default class ObservableColorComponent extends ObservableComponentBase<cc.Color>
{
    /** The [[cc.Node]] to observe. */
    protected value: cc.Color = null;

    /** The initial node to begin with. */
    @property(cc.color)
    protected startValue: cc.Color = cc.Color.WHITE;

    /** @hidden */
    protected onLoad(): void
    {
        super.onLoad();

        if (this.startValue) { this.value = this.startValue; }
    }
}